import { BrowserRouter, Route, Routes } from "react-router-dom";
import AuthProvider from "@/context/AuthProvider";
import RequireAuth from "@/components/RequireAuth/RequireAuth";
import SiteFooter from "@/components/SiteFooter/SiteFooter";
import SiteHeader from "@/components/SiteHeader/SiteHeader";
import HomePage from "@/pages/HomePage/HomePage";
import PropertyDetailsPage from "@/pages/PropertyDetailsPage/PropertyDetailsPage";
import BookingCheckoutPage from "@/pages/BookingCheckoutPage/BookingCheckoutPage";
import MyTripsPage from "@/pages/MyTripsPage/MyTripsPage";
import PaymentPage from "@/pages/PaymentPage/PaymentPage";
import ReviewStayPage from "@/pages/ReviewStayPage/ReviewStayPage";
import BookingConfirmationPage from "@/pages/BookingConfirmationPage/BookingConfirmationPage";
import SignInPage from "@/pages/SignInPage/SignInPage";
import SignUpPage from "@/pages/SignUpPage/SignUpPage";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="app">
          <SiteHeader />
          <main>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/properties/:id" element={<PropertyDetailsPage />} />
              <Route path="/signin" element={<SignInPage />} />
              <Route path="/signup" element={<SignUpPage />} />
              <Route element={<RequireAuth />}>
                <Route
                  path="/properties/:id/book"
                  element={<BookingCheckoutPage />}
                />
                <Route path="/trips" element={<MyTripsPage />} />
                <Route path="/trips/:id/pay" element={<PaymentPage />} />
                <Route path="/trips/:id/review" element={<ReviewStayPage />} />
                <Route
                  path="/trips/:id/confirmation"
                  element={<BookingConfirmationPage />}
                />
              </Route>
            </Routes>
          </main>
          <SiteFooter />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
